export interface IContactHubProps {
  contactUsTitle?: string;
  communicationList?: communicationListType[];
}

type communicationListType =
  | ISingleEmailSupportItem
  | IMultiEmailSupportItem
  | ISinglePhoneSupportItem
  | IMultiplePhoneSupportItem
  | IMultiplePhoneSupportCountryItem
  | IManageCaseItem;

export interface IManageCaseItem {
  title?: string;
  description?: string;
  type?: supportItemType | string;
  supportLinkList?: IManageCaseLinkItem[];
}

export interface IManageCaseLinkItem {
  buttonLink?: string;
  buttonLabel?: string;
  newTab?: boolean;
}
export interface ISingleEmailSupportItem {
  title?: string;
  description?: string;
  buttonText?: string;
  type?: supportItemType | string;
  email?: string;
  emailLabel?: string;
}

interface IMultiEmailSupportItem {
  title?: string;
  description?: string;
  emailButtonText?: string;
  type?: supportItemType | string;
  emailTitle?: string;
  emailList?: IemailListItem[];
  emailCloseLabel?: string;
}

export interface IemailListItem {
  emailLabel?: string;
  emailId?: string;
  emailText?: string;
}

export interface ISinglePhoneSupportItem {
  title?: string;
  description?: string;
  type?: supportItemType | string;
  phoneNumber?: string;
  phoneText?: string;
  timings?: string;
}

export interface IMultiplePhoneSupportItem {
  title?: string;
  description?: string;
  buttonText?: string;
  type?: supportItemType | string;
  closeLabel?: string;
  supportTitle?: string;
  supportSubLabel?: string;
  supportLabel?: string;
  phoneSupportList?: IPhoneSupportListItem[];
}

export interface IPhoneSupportListItem {
  supportType?: string;
  phoneNumberList?: IPhoneNumberItem[];
}

export interface IPhoneNumberItem {
  phoneText?: string;
  phoneNumber?: string;
  timings?: string;
}

export interface IMultiplePhoneSupportCountryItem {
  title?: string;
  description?: string;
  phoneButtonText?: string;
  type?: supportItemType | string;
  phoneCloseLabel?: string;
  countryTitle?: string;
  countrySubLabel?: string;
  countryLabel?: string;
  countryPhoneList?: IphoneSupportCountryListItem[];
}

export interface IphoneSupportCountryListItem {
  countryName?: string;
  phoneSubTitle?: string;
  languageTitle?: string;
  phoneNumberList?: IPhoneNumberItem[];
  languageList?: IphoneLanguageItem[];
}

export interface IphoneLanguageItem {
  language?: string;
  languageOptions?: string;
}

export interface IContactHubEmailSupport {
  emailSupport: ISingleEmailSupportItem | IMultiEmailSupportItem;
}

export enum supportItemType {
  emailSingle = 'emailSingle',
  emailMutli = 'emailMulti',
  phoneSingle = 'phoneSingle',
  phoneMulti = 'phoneMulti',
  phoneWithCountry = 'phoneWithCountry',
  manage = 'manageCase',
}

export enum contactType {
  email = 'email',
  phone = 'phone',
}
